import { call, put, takeEvery, delay } from 'redux-saga/effects' 
import {
    FETCH_GET_IFRAME_DATA,
    FETCH_GET_IFRAME_DATA_SUCCESS
} from '../actions/iframe_actions'
import {
    FETCH_RESOURCE_LOADED,
    FETCH_RESOURCE_ERROR,
} from '../actions/auxiliar_actions'

import { getIframeData } from '../services/iframe_service';

function* fetchGetIframeDataSaga({payload}){
    try {
        let status_response = null;
        do {
            const iframeResponse = yield call(getIframeData, payload.token);
            status_response = iframeResponse.status;
            console.log(iframeResponse)
            let data = iframeResponse ? iframeResponse.data : null
            if(iframeResponse && iframeResponse.status === 200){
                yield put({type: FETCH_GET_IFRAME_DATA_SUCCESS, payload: data})
                yield put({type: FETCH_RESOURCE_LOADED})
            } else {
                yield put({type: FETCH_RESOURCE_ERROR, payload: data});
            }
            if(status_response === 500) {
                // console.log('testing live High Press...')
                yield delay(1000)
            }
        } while(status_response === 500);
    } catch(error){
        yield put({type: FETCH_RESOURCE_ERROR, payload: error})
    }
}

function* watchGetIframeDataSagas(){
    yield takeEvery(FETCH_GET_IFRAME_DATA, fetchGetIframeDataSaga);
}

export default [watchGetIframeDataSagas]